"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.publicActivtyFeedContract = void 0;
const core_1 = require("@ts-rest/core");
const zod_1 = require("zod");
const models_1 = require("./models");
const c = (0, core_1.initContract)();
exports.publicActivtyFeedContract = c.router({
    getActivityFeedItems: {
        method: 'GET',
        path: '/',
        query: zod_1.z.object({
            lastEventId: zod_1.z.optional(zod_1.z.coerce.number()),
        }),
        responses: {
            200: models_1.ZActivityFeedItemResponse,
            404: c.type(),
        },
    },
}, {
    pathPrefix: '/public',
});
//# sourceMappingURL=activityFeed.public.contract.js.map